import { Component, OnInit, Input, ViewChild, OnDestroy, Inject, EventEmitter,Output,Renderer2,ElementRef } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from 'src/environments/environment';
import { MatTabGroup, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CashierService } from './cashier.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, Validators, FormGroup,FormControl } from '@angular/forms';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { ConfirmboxComponent } from '../confirmbox/confirmbox.component';
import { TournamentService } from 'src/app/tournamentpopup/tournament.service';
import { Subscription } from 'rxjs';
import { CreditCardValidator } from 'angular-cc-library';
import { HttpClient } from '@angular/common/http';
import { first } from 'rxjs/operators';
import { FlashMessagesService } from 'angular2-flash-messages';
import { IPayPalConfig, ICreateOrderRequest } from 'ngx-paypal';
import { MainService } from '../_services/main.service';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { UserBalanceData } from './../store/actions/appActions';
declare var $: any;  
declare var window: any;  
@Component({
  selector: 'app-addfund-popup',
  templateUrl: './addfund-popup.component.html',
  styleUrls: ['./addfund-popup.component.scss']
})

export class AddfundPopupComponent implements OnInit, OnDestroy {
  @Input() selectedIndex: number | null;
  @ViewChild('addFundFormElementTop') addFundFormElementTop!: ElementRef;
  fundTabIndex = 1;
  currentUser: any;
  parameters: any;
  sub_checkPromoCode: Subscription;
  sub_joinLeague: Subscription;
  sub_financial: Subscription;
  showSuccess: boolean;
  displayedColumns: string[] = ['cardimg', 'name', 'lastfordigit', 'expirydate', 'action', 'check'];
  ticketsdisplayedColumns: string[] = ['ticket_no', 'contest', 'expired_on', 'ticket_value'];
  historydisplayedColumns: string[] = ['invoice', 'particular', 'trnType', 'amount', 'balance', 'date'];
  pendingdisplayedColumns: string[] = ['date', 'amount', 'action'];
  dataSource;
  historyTable = HISTORY_ELEMENT_DATA;
  pendingCashTable = PENDING_ELEMENT_DATA;
  isMobile = false;
  user_id:Number;
  summaryData:any;
  fundsData:any;
  userData:any
  site_currency:String;
  currency_symbol:String;
  promo_code_value:String;
  assetsUrl:String;
  submitted = false;
  cardSubmitted = false;
  cashOutSubmitted = false;
  verificatioSubmitted = false;
  uploadDocSubmitted = false;
  imageSrc:string | ArrayBuffer;
  showUploadIdSuccessBox=false;
  showUploadBtn =false;
  cashOutConfirmation = false;
  cashOutForfeitConfirmation = false;
  filtertypeVal = 'all';
  currentTabIndex = 0;
  actCorsor = 0;
  endActHis = true;
  AllChecked = false;
  accountHistoryData = [];
  savedCardsData = [];
  pendingCashData = [];
  cardIds = [];
  config: any = null;
  primaryNumberOtp : string = '';
  otpSent = false;
  countDown = 0;
  timer = null;
  confirmDialogRef: MatDialogRef<ConfirmboxComponent>;
  sub_deleteCard:Subscription;
  sub_addNewCard:Subscription;
  sub_summaryInfo:Subscription;
  sub_confirmCashOut:Subscription;
  sub_stateList:Subscription;
  sub_currentlyWinning: Subscription; 
  paypalForm = {promo_code:'',selected_package:'25.000', custom_amt:''};
  paypal_amt = '';
  cardForm:FormGroup;
  cashOutFrom:FormGroup;
  verificationFrom:FormGroup;
  uploadDocForm:FormGroup;
  countNumber=0;
  ipAddress = '192.168.0.149';
  popupTitle = 'Cashier';
  cashoutMethodWord = '';
  successMessage = '';
  errorMessage = '';
  promo_code_validation = {message:'',icon:'far fa-check-circle',icon_color:'',validate:''};
  ticketsData = [];
  paymentDetail = {};
  filtertype = [
    {'key':'all','value':'All'},
    {'key':'add-fund','value':'Deposit'},
    {'key':'add-fund,deposit_bonus','value':'Deposit + Bonus'},
    {'key':'delete_league','value':'Refund'},
    {'key':'deposit-admin','value':'Admin Deposit'},
    {'key':'join_league','value':'Entry'},
    {'key':'league_win','value':'Prize'},
    {'key':'left_league','value':'Left'},
    {'key':'paysafe-transaction-failed','value':'Decline'},
    {'key':'signup_bonus','value':'Signup Bonus'},
    {'key':'deposit-bonus-admin','value':'Bonus From Admin'},
    {'key':'withdrawal-admin','value':'Withdrawal Admin'},
    {'key':'withdrawal','value':'Withdrawal'},
    {'key':'cashout-request','value':'Cashout Request'},
    {'key':'refund-admin','value':'Admin Refund'},
    {'key':'forfeit-bonus','value':'Forfeit Bonus'},
    {'key':'cancel-user','value':'Cancel Cashout'}
  ]
  payPalConfig?: IPayPalConfig; 
  countryList = [{'name':'Canada','code':'CA','id':'38'},{'name':'United States','code':'US','id':'224'}];
  stateList = [];
  dateList = [];
  monthList = [{'key':'1','value':'Jan'},{'key':'2','value':'Feb'},{'key':'3','value':'Mar'},{'key':'4','value':'April'},{'key':'5','value':'May'},{'key':'6','value':'Jun'},{'key':'7','value':'Jul'},{'key':'8','value':'Aug'},{'key':'9','value':'Sep'},{'key':'10','value':'Oct'},{'key':'11','value':'Nov'},{'key':'12','value':'Dec'}];
  yearList = [];  
  financialYearList = []; 
  currntYear=0; 
  FinancialYearSelected=0; 
  cashOutErr = false;
  disableCashOut = false;
  tooltipOption = {
    'placement': 'top',
    'tooltip-class': 'ptooltip'
  }
  amount: any = 0;
  @ViewChild('leftTabs') tabGroup: MatTabGroup;
  @ViewChild('addFundTabs') fundtabGroup: MatTabGroup;
  winAmt: any;
  loadingTicket = false;
  loadingCashOut = false;
  is_campaign = "0";
  tab= 0;
  zip_code_value:number; 
  hideAlert= false;
  uploadTab= false;
  selectedFile = null;
  validPayPal = true;
  min_deposit = 5;
  max_deposit = 1000;
  pending_orders = 0;
  order_message = "";
  selfExclusion = false;
  methodCardtype = '';
  darkMode = false;
  isDisable = false;
  isOpenOtpPopup = false;
  phoneNumerVerified = false;
  otpValue: string = '';
  updatePhoneNumber : string ='';
  phoneNumberControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^[0-9]{10}$/)
  ]);
  isOtpVerified = true;
  countryCode = '';
  paypalCashoutLimit = 0;
  cadCashoutLimit = 0;
  wireTransferCashoutLimit = 0;
  awsUploadUrl = `${environment.assetURL}/assets/default/images/`;
  isAwareVerification = false;
  constructor(public _cashierService: CashierService,
    private _appService: MainService, private formBuilder: FormBuilder, public datepipe: DatePipe, public dialog: MatDialog, 
    private deviceService: DeviceDetectorService, private spinner: NgxSpinnerService, private http: HttpClient, private _flashMessagesService: FlashMessagesService, private currencyPipe: CurrencyPipe, private tournamentService: TournamentService, private renderer:Renderer2,private elementRef:ElementRef, @Inject(MAT_DIALOG_DATA) private data,private store: Store<AppState>, public _mainService : MainService) {
      this.parameters = data;
      this.store.select('authData').subscribe(state => {
        if (state[0]) {
          this.currentUser = state[0];
          this.user_id = this.currentUser.id;
        }
      });
      this.isMobile = this.deviceService.isMobile();
      this.tab = (this.parameters.tab == 1) ? this.parameters.tab : 0;
      if(this.tab!=0)
      this.changeTabData(this.tab);
      this.store.select('DarkModeReducer').subscribe(state => {
        if (state.length > 0) {
          this.darkMode = state[0].isDarkMode;
        }
      });
  }

  ngOnInit() {
    this.site_currency = `${environment.SITE_CURRENCY}`;
    this.currency_symbol = `${environment.CURRENCY_SYMBOL}`;
    this.assetsUrl = `${environment.assetURL}`;

    this.tournamentService.getIpAddress(this.user_id, 0).subscribe(data => {
      if (data.ip) this.ipAddress = data.ip;
      if(data.country) {
        let countryName = data.country.toLowerCase();
        if(!environment.production){
          this.countryCode = '+91'
        } else {
          if (countryName == 'united kingdom') {
            this.countryCode = '+44'
          } else if (countryName == 'canada') {
            this.countryCode = '+1'
          }
        }
      }
    });
    this.currntYear =Number(this.datepipe.transform(Date.now(), 'y'));
    for (let index = 0; index < 5; index++) {
      this.financialYearList.push({'key':(this.currntYear-index).toString(),'value':this.currntYear-index})
      if(index==1)
      this.FinancialYearSelected= this.currntYear-index;
    }
    this.cardForm = this.formBuilder.group({
      card_number: ['', [<any>CreditCardValidator.validateCCNumber]],
      name: ['', Validators.required],
      expiry: ['',[Validators.maxLength(7),<any>CreditCardValidator.validateExpDate]],
      zip_code: ['',[Validators.required,Validators.minLength(5), Validators.maxLength(10)]],
      user_id: [this.user_id,[]],
      ip_address: [this.ipAddress,[]],
      expiry_date: ['']
    });
    
    this.cashOutFrom = this.formBuilder.group({
      cashout_method: ['paypal', Validators.required],
      request_paypal: ['',[Validators.required,Validators.email]],
      cashout_address: [''],
      cashout_holder_name: [''],
      cashout_bank_name: [''],
      cashout_bank_address: [''],
      cashout_account_number: [''],
      cashout_swift_code: [''],
      request_amount: ['',[Validators.required,Validators.pattern("^[0-9]{1,9}(\.[0-9][0-9])?$"),Validators.min(20)]],
      phone_otp:['']
    });
    
    this.verificationFrom = this.formBuilder.group({
      user_id: [this.user_id],
      FirstName: ['', Validators.required],
      LastName: ['', Validators.required],
      dd: ['', Validators.required],
      mm: ['', Validators.required],
      yyyy: ['', Validators.required],
      EmailAddress: ['', [Validators.required,Validators.email]],
      AddressLine1: ['', Validators.required],
      AddressLine2: [''],
      city: ['', Validators.required],
      PostalCode: ['', Validators.required],
      CountryCode: ['', Validators.required],
      StateCode: ['', Validators.required]
    });
    
    this.uploadDocForm = this.formBuilder.group({
      user_id: [this.user_id],
      document: ['', Validators.required],
      image: ['', Validators.required],
      file_name: ['', Validators.required],
    });

    if(this.user_id){ 
      this.summaryInfo();
      this.getCurrentlyWinning();
      if(this.parameters && this.parameters.tab){
        var timepause =  setInterval(()=>{
          if(this.tabGroup && this.parameters.tab > 1){
            this.tab = this.parameters.tab;
            this.changeTab(this.parameters.tab);
            clearInterval(timepause);
          }
        }, 300); 
      }
    }
    this.setCashOutValidators();
    /**Load Jquery for hubzity event tracking */
    if(!this.checkJqueyLoaded() && this.is_campaign == "1") {
      const script = this.renderer.createElement('script');
      script.src = 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js';
      script.onload = () => {
        console.log('script loaded');
      };
      document.getElementsByTagName( "head" )[0].appendChild(script);
      //this.renderer.appendChild(this.elementRef.nativeElement, script);
    }
    this.getSettings();
  }

  get c() { return this.cardForm.controls; }
  get d() { return this.cashOutFrom.controls; }
  get v() { return this.verificationFrom.controls; }
  
  openMethodCard(methodName:any){
    if(methodName == "card"){
      this.changeAddFundTab(0);
    }
    this.methodCardtype = methodName;
  }

  getSettings(){
    this._mainService.getSetting().subscribe(shows => {
      if (shows.status === 'success') {
        let userSettings = shows.entities;
        this.paypalCashoutLimit = Number(userSettings["paypal_cashout_limit"]) || 20;
        this.cadCashoutLimit = Number(userSettings["email_money_cashout_limit"]) || 20;
        this.wireTransferCashoutLimit = Number(userSettings["wire_transfer_cashout_limit"]) || 1000;
      }
    })
  }

  summaryInfo(){
    this.spinner.show();
    this.sub_summaryInfo  = this._cashierService.summaryInfo(this.user_id).subscribe(data=>{
      if(data['status'] === 'success') {
        this.summaryData = data['entities'];
        if(this.summaryData.min_deposit!=null)
        this.min_deposit = parseInt(this.summaryData.min_deposit);
        if(this.summaryData.max_deposit!=null)
        this.max_deposit = parseInt(this.summaryData.max_deposit);
        this.pending_orders = (this.summaryData.pending_orders != null) ? this.summaryData.pending_orders: 0;
        this.order_message = (this.summaryData.order_message != null) ? this.summaryData.order_message: "";
        this.userData = data['entities'].userData;
        this.zip_code_value = this.userData.zip_code;
        var rolloverPercentage = 0;
        if (this.userData.current_rollover_amount) {
          rolloverPercentage = (this.userData.current_rollover_amount / this.userData.total_rollover) * 100;
        }
        this.userData.rollover_percentage = rolloverPercentage.toFixed(2) + '%';
        
        let currentTime = Math.floor(new Date().getTime()/1000);
        this.selfExclusion = (currentTime < parseInt(this.userData.exclusion)) ? true : false;
      }
      this.spinner.hide();
    });

    this._cashierService.verficationInfo().subscribe(data => {
      if (data['status'] === 'success') {
        this.isAwareVerification = data.entities.verification_method && data.entities.verification_method == 'aware' ? true : false;
      }
    })
  }

  addFunds(){
    this.spinner.show();
    this._cashierService.addFunds(this.user_id).subscribe(data=>{
      if(data.status === 'success') {
        this.fundsData = data.entities;
        if(this.fundsData.orderCount > 0 && this.fundsData.isDefault === 'Y') {
          this.promo_code_value = '';
        }else{
          this.promo_code_value = this.fundsData.promo_code;
          this.paypalForm.promo_code = this.fundsData.promo_code;
        }
      }
      this.spinner.hide();
    }); 
  }
  
  changeFiltertype(val){
    this.endActHis  = true;
    this.actCorsor  = 0;
    this.accountHistoryData = [];
  }

  accountHistory(){
    if(this.endActHis && this.currentTabIndex==5){
      this._cashierService.accountHistory(this.user_id,this.filtertypeVal,this.actCorsor).subscribe(data=>{
        if(data.status === 'success' && (data.entities.length > 0)) {
          if (data.entities.length < 10) this.endActHis = false;
          const newData = [];
          data.entities.forEach(element => {
            const txn_action = this.filtertype.find(i => (i.key) === (element.txn_action));
            let txn_val = '';
            if(txn_action){
              txn_val = txn_action.value;
            }else{
              txn_val = '-';
            }
            const balance = this.formalPoints(element.balance);
            const net_amount = this.formalPoints(element.net_amount);

            const newRow = { invoice: element.id, particular: ((element.title)?element.title:'Add Fund'), trnType: txn_val, amount: (this.currency_symbol+''+net_amount),balance:(this.currency_symbol+''+balance),date:this.datepipe.transform(element.created.replace(' ','T'), 'MMM d/yy, h:mm a')};
            newData.push(newRow);
          });
          this.accountHistoryData = this.accountHistoryData.concat(newData);
          //this.accountHistoryData = this.accountHistoryData.concat(data.entities);
          this.actCorsor++;
        }else{
          this.endActHis = false;
        }
      });
    }
  }

  getTickets(){
    this.loadingTicket = true;
    this._cashierService.getTickets(this.user_id).subscribe(data=>{
      this.loadingTicket = false;
      if(data.status === 'success' && (data.entities.length > 0)) {
        this.ticketsData = data.entities;
      }
    });
  }

  pendingCashOut(){
    this.loadingCashOut = true;
    this._cashierService.pendingCashOut(this.user_id).subscribe(data=>{
      this.loadingCashOut = false;
      if(data.status === 'success' && (data.entities.length > 0)) { 
        const newData = [];
        data.entities.forEach(rec => {
          const newRow = {'date':this.datepipe.transform(rec.created, 'MMMM d/yy'), 'amount':rec.request_amount,'id':rec.id};
          newData.push(newRow);
        });
        this.pendingCashData = [];
        this.pendingCashData = this.pendingCashData.concat(newData);
      }
      else {
        this.pendingCashData = [];
      }
    });
  }
  
  cancelCashOut(id){
    this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
      width: '500px',
      data: { 'title': 'Cancel cash out request', 'body': 'Are you sure want to cancel this request?'}
    });
      
    this.confirmDialogRef.afterClosed()
    .subscribe(res => {
        if (res) {
        this.spinner.show();
        const data = {id:id,user_id:this.user_id};
        this.sub_deleteCard = this._cashierService.deleteCashOutRequest(data).subscribe(res=>{
          if(res.status === 'success'){
            this.pendingCashOut();
            this.summaryInfo();
          }
          this.spinner.hide();
        });
        }
    });
  }

  savedCards(){
    this.spinner.show();
    this._cashierService.savedCards(this.user_id).subscribe(data=>{
      if(data['status'] === 'success' && (data['entities'])) {
        const cards = [];
        this.spinner.hide();
        if(data['entities'].paymentMethod){
          data['entities'].paymentMethod.forEach(element => {
            const new_row = { cardimg: '', name: element.cardDetail.nickName, lastfordigit: element.cardDetail.lastDigits, expirydate: (element.cardDetail.month+'/'+element.cardDetail.year), action: 'far fa-trash-alt', check:false, id: element.id }
            cards.push(new_row);
          });
          this.savedCardsData = cards;
        }
      }
    });
  }

  cardCheck(event,type,index,id){
    if(type === 'all'){
      this.AllChecked = true;
      if(event.checked === true){
        this.cardIds  = [];
      }
      let dataSource  = this.savedCardsData.map(x=>Object.assign({},x));
      dataSource.forEach(element => {
        element.check = event.checked;
        this.cardIds.push(element.id);
      });
      this.savedCardsData = [];
      this.savedCardsData = dataSource;
      if(event.checked === false){
        this.cardIds  = [];
      }
    }else{
      this.AllChecked = false;
      if(event.checked === false){
        const card_index = this.cardIds.findIndex(x=>(Number(x.id) === Number(id)));
        this.cardIds.splice(card_index,1);
      }else{
        this.cardIds.push(id);
      }
    }
  }
  
  deleteCardPopup(id=null,index=null){
    if((this.cardIds && this.cardIds.length > 0) || (typeof id !== 'undefined' && id > 0)){
      this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
        width: '500px',
        data: { 'title': 'Information', 'body': 'Are you sure you want to delete selected record?'}
      });
        
      this.confirmDialogRef.afterClosed()
      .subscribe(res => {
         if (res) {
           if (typeof id !== 'undefined' && id > 0) {
             this.cardIds  = [];
             this.cardIds.push(id);
            }
           this.deleteSavedCards();
         }
      });
    }else{
      this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
        width: '500px',
        data: { 'title': 'Information', 'body': 'Please choose record to delete', 'type' : 'alert-box'}
      });
        
      this.confirmDialogRef.afterClosed()
      .subscribe(res => {
         if (res) {
         }
      });
    }
  }

  deleteSavedCards(){
    if (this.cardIds.length > 0) {
      const data = {'user_id':this.user_id,'ids':this.cardIds};
      this.spinner.show();
      this.sub_deleteCard = this._cashierService.deleteCards(data).subscribe(res=>{
        if(res.status === 'success'){
          let dataSource  = this.savedCardsData.map(x=>Object.assign({},x));
          
          this.cardIds.forEach(element => {
            const card_index = dataSource.findIndex(x=>(Number(x.id) === Number(element)));
            dataSource.splice(card_index,1);
          });

          dataSource.forEach(element => {
            element.check = false;
          });

          this.cardIds = [];
          this.savedCardsData = [];
          this.savedCardsData = dataSource;
          this.spinner.hide();
        }
      });  
    }
  }
  
  getPayPalAmount(amt){
    this.paypalForm.selected_package = amt;
    this.paypal_amt = '';
    this.validPayPal = true;
    this.amount = this.formalPoints(this.paypalForm.selected_package); 
  }
  
  onBlur($event) {
    this.paypalForm.selected_package = '';
    this.paypal_amt = $event.target.value;
    this.amount  = this.formalPoints(this.paypal_amt);
    if(this.tab == 1 && this.fundTabIndex == 1) {
      if(this.amount > this.max_deposit && this.amount != ''){
        this.validPayPal = false;
        if($event.type != null && $event.type == 'focusout') this._flashMessagesService.show("The maximum deposit is $"+this.max_deposit, { cssClass: 'alert-danger',timeout: 5000,showCloseBtn:true } );
      } else if(this.amount < this.min_deposit && this.amount != '') {
        this.validPayPal = false;
        if($event.type != null && $event.type == 'focusout') this._flashMessagesService.show("The minimum deposit is $"+this.min_deposit, { cssClass: 'alert-danger',timeout: 5000,showCloseBtn:true } );
      } else {
        this.validPayPal = true;
      }
    }
  }

  checkPromoCode(type){
    if(this.paypalForm.promo_code){
      if( ((this.paypal_amt !== '' && Number(this.paypal_amt) < 3))){
        this._flashMessagesService.show("The Charge amount field must contain a number greater than or equal to 3.", { cssClass: 'alert-danger',timeout: 5000,showCloseBtn:true } );
      }else{
        const data = {'user_id':this.user_id,'order_amount':((this.paypal_amt)?this.paypal_amt:this.paypalForm.selected_package), 'promo_code':this.paypalForm.promo_code};
        this.sub_checkPromoCode = this._cashierService.checkPromoCodeByAmt(data).subscribe(res=>{
          if(res.status === 'success'){
            this.promo_code_validation.message  = res.msg; 
            this.promo_code_validation.validate  = res.validate; 
            if(res.validate === 'yes'){
              this.promo_code_validation.icon  = 'far fa-check-circle';
              this.promo_code_validation.icon_color  = '#52a328';
            }else{
              this.promo_code_validation.icon  = 'far fa-times-circle';
              this.promo_code_validation.icon_color  = '#e8132e';
            }
          }else{
            this._flashMessagesService.show(res.msg, { cssClass: 'alert-danger',timeout: 5000,showCloseBtn:true } );
          }
        });
      }
    }else{
      this._flashMessagesService.show("Promo code is required.", { cssClass: 'alert-danger',timeout: 5000,showCloseBtn:true } );
    }
  }
  

  handleDepositSuccess(data:any) {
    if(data && data.status){
      this.addFunds();
    }else{
      this.scrollToTop();
    }
  }
  
  scrollToTop() {
    this.addFundFormElementTop.nativeElement.scrollTop = 0;
  }
  
  onCardSubmit() {
    this.cardSubmitted = true;
    if (this.cardForm.invalid) {  
      return;
    } else { 
      this.isDisable = true;
      this.spinner.show();
      const cardExpiryDate  = this.c.expiry.value.replace(/ /gi,'');
      this.cardForm.controls['expiry_date'].setValue(cardExpiryDate);
      this.sub_addNewCard = this._cashierService.addNewCard(this.cardForm.value).pipe(first()).subscribe(
        data => {
          this.isDisable = false;
          if (data.status === 'success') {
            this.changeTab(1);
            this.cardForm.controls['zip_code'].setValue('');
          } else {
            this._flashMessagesService.show(data.message, { cssClass: 'alert-danger',timeout: 7000,showCloseBtn:true } );
          } 
          this.spinner.hide();
          this.cardSubmitted = false;
        },
        error => {
          this.spinner.hide();
          console.log(error);
        });
    }
  }
  
  getCurrentlyWinning(){
    if(this.currentUser){
      this.sub_currentlyWinning = this._appService.getCurrentlyWinning(this.user_id).subscribe((res:any)=>{
        if(res){
          this.winAmt = res.currently_winning;
        }
      });
    }
  }
  
  setCashOutValidators() {
    const request_paypal = this.cashOutFrom.get('request_paypal');
    const cashout_address = this.cashOutFrom.get('cashout_address');
    const cashout_holder_name = this.cashOutFrom.get('cashout_holder_name');
    const cashout_bank_name = this.cashOutFrom.get('cashout_bank_name');
    const cashout_bank_address = this.cashOutFrom.get('cashout_bank_address');
    const cashout_account_number = this.cashOutFrom.get('cashout_account_number');
    const cashout_swift_code = this.cashOutFrom.get('cashout_swift_code');
    const request_amount = this.cashOutFrom.get('request_amount');
    
    this.cashOutFrom.get('cashout_method').valueChanges
      .subscribe(cashout_method => {
        if (cashout_method === 'paypal') {
          request_paypal.setValidators([Validators.required,Validators.email]);
          request_amount.setValidators([Validators.required,Validators.pattern("^[0-9]{1,9}(\.[0-9][0-9])?$"),Validators.min(this.paypalCashoutLimit)]);
          cashout_address.setValidators(null);
          cashout_holder_name.setValidators(null);
          cashout_bank_name.setValidators(null);
          cashout_bank_address.setValidators(null);
          cashout_account_number.setValidators(null);
          cashout_swift_code.setValidators(null);
        }
        else if (cashout_method === 'email_money_transfer') {
          request_paypal.setValidators(null);
          cashout_address.setValidators(null);
          request_amount.setValidators([Validators.required,Validators.pattern("^[0-9]{1,9}(\.[0-9][0-9])?$"),Validators.min(this.cadCashoutLimit)]);
          cashout_holder_name.setValidators(null);
          cashout_bank_name.setValidators(null);
          cashout_bank_address.setValidators(null);
          cashout_account_number.setValidators(null);
          cashout_swift_code.setValidators(null);
        }
        else if (cashout_method === 'wire_transfer') {
          cashout_holder_name.setValidators([Validators.required]);
          request_amount.setValidators([Validators.required,Validators.pattern("^[0-9]{1,9}(\.[0-9][0-9])?$"),Validators.min(this.wireTransferCashoutLimit)]);
          cashout_address.setValidators([Validators.required]);
          cashout_bank_name.setValidators([Validators.required]);
          cashout_bank_address.setValidators([Validators.required]);
          cashout_account_number.setValidators([Validators.required]);
          cashout_swift_code.setValidators([Validators.required]);
          request_paypal.setValidators(null);
        }

        request_paypal.updateValueAndValidity();
        request_amount.updateValueAndValidity();
        cashout_address.updateValueAndValidity();
        cashout_holder_name.updateValueAndValidity();
        cashout_bank_name.updateValueAndValidity();
        cashout_bank_address.updateValueAndValidity();
        cashout_account_number.updateValueAndValidity();
        cashout_swift_code.updateValueAndValidity();
      });
  }

  onCashOutSubmit() {
    this.cashOutSubmitted = true;
    // stop here if form is invalid
    if (this.cashOutFrom.invalid) {
      return;
    }else if(parseFloat(this.cashOutFrom.value.request_amount) > parseFloat(this.userData.redeemable_balance)){
      this._flashMessagesService.show("The Request amount must be less than or equal available balance.", { cssClass: 'alert-danger',timeout: 7000,showCloseBtn:true } );
    } else { 
      if(this.cashOutFrom.value.cashout_method === 'email_money_transfer') {
        this.cashoutMethodWord  = this.cashOutFrom.value.cashout_method.replace(/_/g,' ');
        this.cashoutMethodWord  += ' (CAD Only)';
      }else{
        this.cashoutMethodWord  = this.cashOutFrom.value.cashout_method.replace(/_/g,' ');
      }
      
      if (parseFloat(this.userData.bonus_amount) > 0) {
        this.cashOutForfeitConfirmation = true;  
      }
      else {
        this.cashOutConfirmation = true;
      }
    }
  }

  openOtpPopup(){
    this.otpValue  = '';
    this.spinner.show();
    this.cashOutSubmitted = true;
    this.primaryNumberOtp = (this.currentUser && this.currentUser.primary_number && this.currentUser.primary_number) ? this.currentUser.primary_number.slice(-4):"";
    if(this.primaryNumberOtp){
      this.sendPhoneOtp();
    }else{
      this.isOpenOtpPopup = false;
      this.phoneNumerVerified = true;
      this.spinner.hide();
    }
  }
  sendPhoneOtp(phoneNumber = ''){
    this._cashierService.sendPhoneOtp(phoneNumber).subscribe(data => {
      this.isOtpVerified = false;
      if(data && data.status == 'success'){
        this.isOtpVerified = true;
        this.phoneNumerVerified = false;
        this.isOpenOtpPopup = true;
        this.otpSent = true;
        this.countDown = 60;
        this.getCountdown();
        this.spinner.hide();
        if(phoneNumber) {
          this.currentUser['primary_number'] = phoneNumber
          this.primaryNumberOtp = phoneNumber.slice(-4);
        };
      }else{
        if(phoneNumber){
          this.phoneNumerVerified = true;
           this.isOpenOtpPopup = false;
        }else{
          this.isOpenOtpPopup = true
          this.phoneNumerVerified = false;
        }
        this.spinner.hide();
        setTimeout(()=>{
          this._flashMessagesService.show(data.message, { cssClass: 'alert-danger',timeout: 10000,showCloseBtn:false } )},500);
      }
    });
  }
  
  submitPhoneVerified() {
    if (this.phoneNumberControl.valid) {
     const primaryNumber = this.countryCode+' '+this.phoneNumberControl.value;
      this.otpValue  = '';
      this.spinner.show();
      this.cashOutSubmitted = true;
      this.sendPhoneOtp(primaryNumber);
    }
  }

  getErrorMessage(): string {
    if (this.phoneNumberControl.hasError('required')) {
      return 'Phone Number is required.';
    }
    if (this.phoneNumberControl.hasError('pattern')) {
      return 'Please enter a valid phone number.';
    }
    return '';
  }

  submitVerify(){
    this.cashOutFrom.patchValue({ phone_otp: this.otpValue });
    this.cashOutSubmit('confirm');
  }

  validateOtp(){
    this.cashOutSubmitted = true;
    if(this.otpValue && this.otpValue.length == 6) this.cashOutSubmitted = false;
  }

  getCountdown(){
    if(this.timer == null) {
      this.timer = setInterval(() => {
        this.countDown--;
        if(this.countDown == 0) {
          this.timer.clearInterval();
          this.timer = null;
        }
      }, 1000); 
    }
  }

  cashOutSubmit(type:String){
    if(type === 'cancel') {
      this.cashOutFrom.reset();
      this.cashOutFrom.controls['cashout_method'].setValue('paypal');
      this.cashOutSubmitted = false;
      this.cashOutConfirmation = false;
      this.cashOutForfeitConfirmation = false;
    }
    else if (type === 'back') {
      this.cashOutSubmitted = false;
      this.cashOutConfirmation = false;
      this.cashOutForfeitConfirmation = false;
    }
    else{
      // confirmCashOut
      this.spinner.show();
      let address = '';
      let formFields = this.cashOutFrom.value;
      const fromData  = {
        'user_id': this.user_id,
        'amount': formFields.request_amount,
        'method': formFields.cashout_method
      };

      if(formFields && formFields.phone_otp) fromData['phone_otp'] = formFields.phone_otp;

      if (this.cashOutFrom.value.cashout_method === 'paypal') {
        fromData['address'] = formFields.request_paypal;
      }
      else if (this.cashOutFrom.value.cashout_method === 'cheque_by_email') {
        fromData['address'] = formFields.cashout_address;
      }
      else if (this.cashOutFrom.value.cashout_method === 'wire_transfer') {
        fromData['address'] = formFields.cashout_address;
        fromData['bank_holder_name'] = formFields.cashout_holder_name;
        fromData['bank_name'] = formFields.cashout_bank_name;
        fromData['bank_address'] = formFields.cashout_bank_address;
        fromData['bank_account_number'] = formFields.cashout_account_number;
        fromData['bank_swift_code'] = formFields.cashout_swift_code;
      }
      
      this.sub_confirmCashOut = this._cashierService.confirmCashOut(fromData).pipe(first()).subscribe(
        data => {
          if (data.status === 'success') {
            this.summaryInfo();
            this.pendingCashOut();
            this.cashOutFrom.reset();
            this.cashOutFrom.controls['cashout_method'].setValue('paypal');
            this.cashOutSubmitted = false;
            this.cashOutConfirmation = false;
            this.cashOutForfeitConfirmation = false;
            this.isOpenOtpPopup = false;
            this.phoneNumerVerified = false;
            this.countDown = 0;
           setTimeout(()=>{
            this._flashMessagesService.show(data.msg, { cssClass: 'alert-success',timeout: 7000,showCloseBtn:true });
           },500);
          } else { 
            this.cashOutSubmitted = true;
            this._flashMessagesService.show(data.msg, { cssClass: 'alert-danger',timeout: 7000,showCloseBtn:true });
          } 
          this.spinner.hide();
        },
        error => {
          this.spinner.hide();
          console.log(error);
        });
    }
  }
  
  cashOutForfitSubmit(type:String){
    if(type === 'cancel') {
      this.cashOutFrom.reset();
      this.cashOutFrom.controls['cashout_method'].setValue('paypal');
      this.cashOutSubmitted = false;
      this.cashOutConfirmation = false;
      this.cashOutForfeitConfirmation = false;
    }
    else{
      this.cashOutConfirmation = true;
      this.cashOutForfeitConfirmation = false;
    }
  }

  goToVerify(){
    this.changeTab(7);
  }

  changeTab(val) {
    this.validPayPal = true;
    if (this.fundTabIndex && val > 3) {
      val = val - 2;
    }
    this.tabGroup.selectedIndex = val;
  }

  changeTabData(val) {
    if (this.fundTabIndex && val > 1) {
      val = val + 2;
    }
    this.validPayPal = true;
    this.currentTabIndex  = val;
    this.popupTitle = 'Cashier';
    if (val === 0) {
      this.summaryInfo();
    } else if (val === 1) {
      this.paymentDetail = {status:'',message: '',class:''};
      this.checkUserEligibility();
    } else if (val === 2) {
      this.cardSubmitted = false;
      this.cardForm.controls['card_number'].setValue('');
      this.cardForm.controls['name'].setValue('');
      this.cardForm.controls['expiry'].setValue('');
    } else if (val === 3) {
      this.savedCards();
    }else if (val === 4) {
      if(this.userData.payment_verified === 'N'){
        this.cashOutErr = true;
        this.disableCashOut = true;
      }
      this.pendingCashOut();
    }else if (val === 6) {
      this.getTickets();
    }else if (val === 7) {
      this.showVerification();
    }
  }

  changeAddFundTab(val) {
    this.fundTabIndex = val;
    this.promo_code_validation  = {message:'',icon:'far fa-check-circle',icon_color:'',validate:''};
    if (val === 1) {
      this.methodCardtype = "paypal" ;
      this.initConfig();
    }else{
      this.methodCardtype = "card";
    }
  }
  
  initConfig() {
    this.spinner.show();
    this.payPalConfig = {
      currency: `${environment.SITE_CURRENCY}`,
      clientId:  `${environment.PAYPAL_CLIENT_ID}`,
      createOrderOnClient: (data) => <ICreateOrderRequest>{
        intent: 'CAPTURE',
        purchase_units: [
          {
            amount: {
              currency_code: `${environment.SITE_CURRENCY}`,
              value: (this.amount > 0) ? this.amount : 25.00
            }
          }
        ]
      },
      advanced: {
        commit: 'true'
      },
      style: {
        tagline:true,
        label: 'checkout',
        size: "responsive",
        shape: "pill",
        layout: "horizontal"
      },
      onApprove: (data, actions) => {
        data['paymentID'] = data['orderID']; 
        const fromData  = {'payment_id':data['paymentID'],'user_id':this.user_id,'promo_code':this.paypalForm.promo_code,'order_amount':((this.paypal_amt)?this.paypal_amt:this.paypalForm.selected_package),'response':data, 'currency':`${environment.SITE_CURRENCY}`, 'user_agent':this.deviceService.userAgent,'ip':this.ipAddress};
        this.spinner.show();
        this._cashierService.validatePaypal(fromData).pipe(first()).subscribe(
          response => {
            if (response.error != true) {
              return actions.order.capture().then((details) => {
                  const total_order_amount = parseFloat(fromData.order_amount) + parseFloat(response.bonus_amount);
                  this.paymentDetail = {status: 'processing', message: 'Please check back momentarily and refresh the page. <br><br> You will receive an email receipt confirming if your deposit has been successful or unsuccessful!',class:'pending' };
                  var counter = 0;
                  var timeInt = setInterval(()=>{
                    this.verifyPaypalPaymentStatus(fromData['payment_id'], (checkData)=>{
                      counter++;
                      if(counter == 3 || checkData.status != 'pending') {
                        //Break the real time payment status checking if it is not getting success/failure in x (counter) calls
                        clearInterval(timeInt);
                        if(checkData.status == 'success') {
                            this.userData.dollar_balance = parseFloat(this.userData.dollar_balance) + total_order_amount;
                            /**Update store data */
                            this.store.dispatch(new UserBalanceData(
                              this.userData.dollar_balance
                            ));
                            this.paymentDetail = {status: 'completed', message: '$'+(+total_order_amount).toFixed(2).replace(/(\.0+|0+)$/, '')+' has been added to your account', class:'success' };
                        } else if(checkData.status == 'failed') {
                          this.paymentDetail = {status: 'failed', message: checkData.message, class:'failure' };
                        } else {
                          this.paymentDetail = {status: 'processing', message: 'Please check back momentarily and refresh the page. <br><br> You will receive an email receipt confirming if your deposit has been successful or unsuccessful!',class:'pending' };
                        }
                        //this._flashMessagesService.show(checkData.message, { cssClass: 'alert-success',timeout: 7000,showCloseBtn:true } );
                        this.spinner.hide();
                      }
                    });
                  },1500); 
              });
            } else { 
              this._flashMessagesService.show((response.errorMessage).join('<br />'), { cssClass: 'alert-danger',timeout: 7000,showCloseBtn:true } );
              this.spinner.hide();
            } 
        });
      },
      onCancel: (data, actions) => { 
      },
      onError: err => {
        console.log('OnError', err);
        this._flashMessagesService.show("Something went wrong. Please try again later.", { cssClass: 'alert-danger',timeout: 7000,showCloseBtn:true } );
      },
      onClick: () => { 
      },
    };
    if(this.payPalConfig){
      this.spinner.hide(); 
    }
  }
  
  verifyPaypalPaymentStatus(payment_id, callback) {
    this._cashierService.checkPaypalPaymentStatus(payment_id).pipe(first()).subscribe(
      data => {
        callback(data);
      },
      error => {
        callback(error);
      });
  }

  savePaypalAmount(fromData){
    this.sub_confirmCashOut = this._cashierService.validatePaypal(fromData).pipe(first()).subscribe(
      data => {
        if (data.status === 'success') {
          //this._flashMessagesService.show("Your payment has been successfully submitted.", { cssClass: 'alert-danger',timeout: 7000,showCloseBtn:true } );
          var counter = 0;
          this.spinner.show();
          var timeInt =  setInterval(()=>{
            this.verifyPaypalPaymentStatus(fromData['payment_id'], (checkData)=>{
              counter++;
              if(counter == 8 || checkData.status != 'pending') {
                clearInterval(timeInt);
                if(checkData.status == 'success') {
                  const total_order_amount = parseFloat(fromData.order_amount) + parseFloat(data.bonus_amount);
                  this.userData.dollar_balance = parseFloat(this.userData.dollar_balance) + total_order_amount;
                  /**Update store data */
                  this.store.dispatch(new UserBalanceData(
                    this.userData.dollar_balance
                  ));
                }
                this._flashMessagesService.show(checkData.message, { cssClass: 'alert-success',timeout: 7000,showCloseBtn:true } );
                this.spinner.hide();
              }
              if(this.userData.dollar_balance != null && this.userData.dollar_balance == 0 && this.is_campaign == "1") this.trackHubZityEvents("5");
            });
          },1500);
        } else { 
          this._flashMessagesService.show(data.errorMessage, { cssClass: 'alert-danger',timeout: 7000,showCloseBtn:true } );
          this.spinner.hide();
        } 
       
      },
      error => {
        console.log(error);
      });
  }

  keyPress(event: any) {
    try {
      const pattern = /[0-9\+\.\ ]/;
      const inputChar = String.fromCharCode(event.charCode);
      if (event.keyCode !== 8 && !pattern.test(inputChar)) {
        event.preventDefault(); 
      }
      if(this.tab == 1 && this.fundTabIndex == 1) {
        setTimeout(() => {
          if(event != null && event.target != null && parseFloat(event.target.value) >= this.min_deposit && parseFloat(event.target.value) <= this.max_deposit){
            this.validPayPal = true;
          }
        }, 100);
      }
    }
    catch {

    }
  }

  showVerification(){
    let currentTime = Math.floor(new Date().getTime()/1000);
    let diff = currentTime - this.userData.doc_upload_time;
    let min = (diff > 0) ? diff/60 : 0;
    
    this.showUploadIdSuccessBox = (min < 30) ? true : false;
    this.dateList = [];
    this.yearList = [];
    for (let index = 1; index <= 31; index++) {
      this.dateList.push({'key':index.toString(),'value':index})
    }
    for (let index = Number(this.datepipe.transform(Date.now(), 'y')); index >= 1905; index--) {
      this.yearList.push({'key':index.toString(),'value':index})
    }

    if(this.userData){
      const dob = this.userData.dob.split('-');
      const dd  = Number((dob[2])?dob[2]:'');
      const mm  = Number((dob[1])?dob[1]:'');
      const yy  = Number((dob[0])?dob[0]:''); 
      this.v['dd'].setValue(dd.toString());
      this.v['yyyy'].setValue(yy.toString());
      this.v['mm'].setValue(mm.toString());
      this.v['EmailAddress'].setValue(this.userData.email);
      this.v['AddressLine1'].setValue(this.userData.address);
      this.v['city'].setValue(this.userData.hometown);
      this.v['PostalCode'].setValue(this.userData.zip_code);
    }
  }

  onVerificationSubmit(el:HTMLElement){
    this.verificatioSubmitted = true;
    // stop here if form is invalid
    if (this.verificationFrom.invalid) {
      return;
    } else {  
      this.spinner.show();      
      this.sub_confirmCashOut = this._cashierService.tsevoVerification(this.verificationFrom.value).pipe(first()).subscribe(
        data => {
          if(data.status == "success") {
            this.hideAlert = true;
            this._flashMessagesService.show('Thanks for providing the information. You will receive an email when it has been reviewed. This usually takes less than an hour.', { cssClass: 'alert-success',timeout: 10000,showCloseBtn:true });
            el.scrollIntoView();  
          } else {
            this.userData.verification_attempts++;
          }
          this.spinner.hide();
        },
        error => {
          this.spinner.hide();
          console.log(error);
        });
    }
  }

  onSelectFile(files) {
    const file1: File = files[0];
    var file = file1;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    reader.onload = e => this.imageSrc = reader.result;
    reader.readAsDataURL(file);
    // var base64result =this._handleReaderLoaded.bind(this);
    this.uploadDocForm.get('file_name').setValue(file.name);
    this.uploadDocForm.get('image').setValue(files[0]);   
    this.selectedFile = files[0];   
    // reader.onloadend = base64result;
    //reader.readAsDataURL(file);
    this.showUploadBtn = true;
  }

  resetFile() {
    this.imageSrc = null;
  }

  _handleReaderLoaded(e) {
    // let reader = e.target;
    // var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    // this.uploadDocForm.get('image').setValue(base64result);   
  }

  onDocSubmit(){
    this.uploadDocSubmitted = true;
    // stop here if form is invalid
    if (this.uploadDocForm.invalid) {
      return;
    } else {
      this.spinner.show();   
      let form = new FormData();  
      form.append('document',this.selectedFile, this.selectedFile.name);
      form.append('login_user_id',this.currentUser.id); 
      this.sub_confirmCashOut = this._cashierService.submitVerificationDocument(form).pipe(first()).subscribe(
        data => {
          if (data.status === 'success') {
            setTimeout(()=>{this.showUploadIdSuccessBox =true;},5000)
            this.summaryInfo();
          this._flashMessagesService.show('Thanks for uploading your ID. You will receive an email when it has been reviewed. This usually takes less than an hour.', { cssClass: 'alert-success',timeout: 10000,showCloseBtn:true });
          this.userData.doc_upload_time =Math.floor(new Date().getTime()/1000);
          } else {  
            this._flashMessagesService.show('Something went wrong. Please try again later.', { cssClass: 'alert-danger',timeout: 5000,showCloseBtn:true } );
          } 
          this.spinner.hide();
        },
        error => {
          this.spinner.hide();
          console.log(error);
        });
    }
  }

  formalPoints(val){
    if(typeof val !== 'undefined' && val !== null){
      const abc = val.toString().split('.') ;
      if(abc[1] && Number(abc[1]) > 0){
        const dec = abc[1].split('');
        if(dec[1] && Number(dec[1]) === 0 && Number(dec[0]) > 0){
          return (abc[0]+'.'+dec[0]+dec[1]);
        }else if(dec[0] && Number(dec[0]) === 0){
          return abc[0];
        }else{
          return (abc[0]+'.'+abc[1].slice(0,2));
        }
      }else{
        return abc[0];
      }
    }else{
      return '';
    }
  }
  
  ngOnDestroy(){
    if(this.sub_deleteCard) { this.sub_deleteCard.unsubscribe(); }
    if(this.sub_addNewCard) { this.sub_addNewCard.unsubscribe(); }
    if(this.sub_summaryInfo) { this.sub_summaryInfo.unsubscribe(); }
    if(this.sub_confirmCashOut) { this.sub_confirmCashOut.unsubscribe(); }
    if(this.sub_stateList) { this.sub_stateList.unsubscribe(); }
  }

  getStateList(country_code){
    const country  = this.countryList.find(x=>(x.code == country_code));
    this.sub_stateList = this._cashierService.stateList(country.id).subscribe(res=>{
      if(res.status === 'success'){
        this.stateList  = res.entities;
      }
    });
  }
  
  checkUserEligibility() {
    this.spinner.show();
    this.tournamentService.getUserLocation(this.user_id, locationData => {
      var eligibilityData = {
        'user_id' : this.user_id,
        'PublicIP' : locationData['ip'],
        'country_name' : locationData['country'],
        'state_name' : locationData['state'],
        'user_dob' : locationData['user_dob'],
        'type' : 'cash',
        'display_name' : this.currentUser['drafters_id']
      };
      this._cashierService.checkUserEligibility(eligibilityData).subscribe(res => {
        this.spinner.hide();
        if (typeof res !== 'undefined') {
          if (res.status == 'success') {
            this.submitted = false;
            this.addFunds();
            this.initConfig();
          }
          else {
            const isDobWarning = this.currentUser && this.currentUser.verification_method == 'aware' && this.currentUser.payment_verified == 'N' && this.currentUser.verify_before_deposits && res.type == 'dob';
            if(!isDobWarning){
              this.changeTab(0);
              this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
                width: (res.type == 'age_18') ? '500px' : '800px',
                data: { 'title': "Eligibility Warning", 'body': res.message,'type':res.type }
              });
              this.confirmDialogRef.afterClosed()
              .subscribe(res => {})
            }
          }
        }
      });
    });
  }

  cashOutErrHide(){
    this.cashOutErr = false;
  }
  uploadDocAction(action){
    if(action=='change')
    this.uploadTab = true;
    else
    this.hideAlert = true
  }

  
 trackHubZityEvents(TRACKING_CONVERSION_STAGE){
   console.log("TRACKING_CONVERSION_STAGE: ",TRACKING_CONVERSION_STAGE);
	/* Hubzity conversion stage tracking start */
	if (window.trackingStoreSession !== undefined && window.trackingConversion !== undefined) {
		window.trackingStoreSession();
		window.trackingConversion(TRACKING_CONVERSION_STAGE);
	} else {
		var head = document.getElementsByTagName("head")[0];
		var trackingScript = document.createElement("script");
		
		trackingScript.setAttribute("async", 'true');
		trackingScript.setAttribute("src", "//static.rtbaxs.io/tracking.min.js?ts=" + new Date().getTime());
		
		trackingScript.addEventListener("load", function () {
			window.trackingStoreSession();
			window.trackingConversion(TRACKING_CONVERSION_STAGE); //use this in each following pages in case you want to track their loading
		});
		
		trackingScript.addEventListener("error", function () {
			console.log("Failed to load Hubzity tracking SDK");
		});
		
		head.appendChild(trackingScript);
	}
	/* Hubzity conversion stage tracking end */
}
 
checkJqueyLoaded() {
    let isFound = false;
    let scripts = document.getElementsByTagName("script")
    for (let i = 0; i < scripts.length; ++i) {
        if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("1.7.1/jquery.min.js")) {
            isFound = true;
        }
    }
    //console.log("jquery loaded:",isFound);
    return isFound;
}
sendFinancialReport(){
  if(this.FinancialYearSelected==0){
    this.setErrorSuccessMessage('Please select year','error',3000);
    return false;
  }
    this.sub_financial = this._cashierService.getFinancialReport(this.user_id,this.FinancialYearSelected).subscribe(res=>{
      this.setErrorSuccessMessage(res.message,res['status'] == 'success'?'success':'error',5000)
  });
}
setErrorSuccessMessage(message,type,time=5000){
  this.errorMessage = '';
  this.successMessage = '';
  setTimeout(()=>{
      this.errorMessage = '';
      this.successMessage = '';
  },time);
    if(type=='success'){
      this.errorMessage = '';
    this.successMessage=message;
    }else{
      this.successMessage = '';
      this.errorMessage=message;
    }
}
}

export interface PeriodicElement {
  cardimg: any;
  name: string;
  lastfordigit: number;
  expirydate: any;
  action: any;
  check: any;

}

const ELEMENT_DATA: PeriodicElement[] = [
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/visa-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/master-card-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/maestro-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/cirrus-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },
  { cardimg: `${environment.assetURL}`+'/assets/default/images/card/american-express-dark.png', name: 'Dai Jiang', lastfordigit: 9090, expirydate: '12/2021', action: 'far fa-trash-alt', check: '' },

];

export interface HistoryPeriodicElement {
  invoice: any;
  particular: any;
  trnType: any;
  amount: any;
  balance: any;
  date: any;
}

const HISTORY_ELEMENT_DATA: HistoryPeriodicElement[] = [
  { invoice: '4586', particular: 'Refund for nfl league (Week 15 cobra 2QB($450 to 1st)', trnType: 'Left', amount: '$22', balance: '$500.57', date: '18 Oct 2018' },
  { invoice: '4586', particular: 'Refund for nfl league (Week 15 cobra 2QB($450 to 1st)', trnType: 'Left', amount: '$22', balance: '$500.57', date: '18 Oct 2018' },
  { invoice: '4586', particular: 'Refund for nfl league (Week 15 cobra 2QB($450 to 1st)', trnType: 'Left', amount: '$22', balance: '$500.57', date: '18 Oct 2018' },
  { invoice: '4586', particular: 'Refund for nfl league (Week 15 cobra 2QB($450 to 1st)', trnType: 'Left', amount: '$22', balance: '$500.57', date: '18 Oct 2018' },
  { invoice: '4586', particular: 'Refund for nfl league (Week 15 cobra 2QB($450 to 1st)', trnType: 'Left', amount: '$22', balance: '$500.57', date: '18 Oct 2018' },
  { invoice: '4586', particular: 'Refund for nfl league (Week 15 cobra 2QB($450 to 1st)', trnType: 'Left', amount: '$22', balance: '$500.57', date: '18 Oct 2018' }
];

export interface PendingPeriodicElement {
  date: any;
  amount: any;
  action: any;

}

const PENDING_ELEMENT_DATA: PendingPeriodicElement[] = [
  { date: '18 Oct 2018', amount: '$20', action: 'far fa-trash-alt' },
  { date: '18 Oct 2018', amount: '$20', action: 'far fa-trash-alt' },
  { date: '18 Oct 2018', amount: '$20', action: 'far fa-trash-alt' },
  { date: '18 Oct 2018', amount: '$20', action: 'far fa-trash-alt' },
  { date: '18 Oct 2018', amount: '$20', action: 'far fa-trash-alt' },
  { date: '18 Oct 2018', amount: '$20', action: 'far fa-trash-alt' },
  { date: '18 Oct 2018', amount: '$20', action: 'far fa-trash-alt' },
  { date: '18 Oct 2018', amount: '$20', action: 'far fa-trash-alt' },

];
